import React from "react"
import ScheduleList from "../../../components/schedule/schedule_list/ScheduleList"
import { EScheduleListType } from "../../../models"

interface IProps {
}

const SchedulePlanners: React.SFC<IProps> = (props: IProps) => {
	return (
		<ScheduleList
			type={EScheduleListType.Planner}
		/>
	)
}

export default SchedulePlanners